export const AUTH_TEMPLATE_TEXT =
  'Приветствуем вас на Портале Центре опережающей профессиональной подготовки. ' +
  'Для доступа в Личный кабинет вам необходимо авторизоваться или зарегистрироваться на портале.<br/> В Личном кабинете вы сможете:';



// WEBPACK FOOTER //
// ./src/pages/auth/AuthConsts.ts